import { useRemoteService } from "./authService";

export const UserService = () => {
  const { sendPostToServerWithOutToken, sendGetToServer, sendPostToServer } =
    useRemoteService();

  const fetchRegions = async () => {
    try {
      const { returnCode, returnObject } = await sendPostToServerWithOutToken(
        "address/regions",
        {}
      );
      return returnCode === 200 ? returnObject : [];
    } catch (error) {
      console.error("Error fetching regions:", error);
      return [];
    }
  };

  const fetchDistricts = async (regionId: number) => {
    try {
      const { returnCode, returnObject } = await sendPostToServerWithOutToken(
        "address/districts",
        { regionId }
      );
      return returnCode === 200 ? returnObject : [];
    } catch (error) {
      console.error("Error fetching districts:", error);
      return [];
    }
  };

  const fetchCounties = async (districtId: number) => {
    try {
      const { returnCode, returnObject } = await sendPostToServerWithOutToken(
        "address/counties",
        { districtId }
      );
      return returnCode === 200 ? returnObject : [];
    } catch (error) {
      console.error("Error fetching counties:", error);
      return [];
    }
  };

  const fetchSubCounties = async (countyId: number) => {
    try {
      const { returnCode, returnObject } = await sendPostToServerWithOutToken(
        "address/sub-counties",
        { countyId }
      );
      return returnCode === 200 ? returnObject : [];
    } catch (error) {
      console.error("Error fetching sub-counties:", error);
      return [];
    }
  };

  const fetchParishes = async (subCountyId: number) => {
    try {
      const { returnCode, returnObject } = await sendPostToServerWithOutToken(
        "address/parishes",
        { subCountyId }
      );
      return returnCode === 200 ? returnObject : [];
    } catch (error) {
      console.error("Error fetching parishes:", error);
      return [];
    }
  };

  const fetchInstitutions = async () => {
    try {
      const { returnCode, returnObject } = await sendGetToServer(
        "institutions/get-all"
      );
      return returnCode === 200 ? returnObject.institutions || [] : [];
    } catch (error) {
      console.error("Error fetching institutions:", error);
      return [];
    }
  };

  const fetchBranches = async (institutionId: string) => {
    try {
      const { returnCode, returnObject } = await sendGetToServer(
        `institutions/get-branches-on-institution/${institutionId}`
      );
      return returnCode === 200 ? returnObject.branches || [] : [];
    } catch (error) {
      console.error("Error fetching branches:", error);
      return [];
    }
  };

  const fetchServiceCategories = async () => {
    try {
      const { returnCode, returnObject } = await sendGetToServer(
        "services/fetch-all-categories"
      );
      return returnCode === 200 ? returnObject.categories || [] : [];
    } catch (error) {
      console.error("Error fetching service categories:", error);
      return [];
    }
  };

  const createInstitution = async (institutionData: any) => {
    try {
      const { returnCode, returnObject } = await sendPostToServerWithOutToken(
        "institutions/create",
        institutionData
      );
      return {
        success: returnCode === 200 || returnCode === 201,
        data: returnObject,
      };
    } catch (error) {
      console.error("Error creating institution:", error);
      return { success: false, error };
    }
  };

  const createBranch = async (branchData: any) => {
    try {
      const { returnCode, returnObject } = await sendPostToServerWithOutToken(
        "institutions/branches/create",
        branchData
      );
      return {
        success: returnCode === 200 || returnCode === 201,
        data: returnObject,
      };
    } catch (error) {
      console.error("Error creating branch:", error);
      return { success: false, error };
    }
  };

  const createServiceCategory = async (categoryData: any) => {
    try {
      const { returnCode, returnObject } = await sendPostToServerWithOutToken(
        "services/create-category",
        categoryData
      );
      return {
        success: returnCode === 200 || returnCode === 201,
        data: returnObject,
      };
    } catch (error) {
      console.error("Error creating service category:", error);
      return { success: false, error };
    }
  };

  const createUser = async (userData: any) => {
    try {
      const { returnCode, returnObject, returnMessage } =
        await sendPostToServerWithOutToken("auth/register", userData);
      return {
        success: returnCode === 200 || returnCode === 201,
        data: returnObject,
        message: returnMessage,
      };
    } catch (error) {
      console.error("Error creating user:", error);
      return { success: false, error };
    }
  };

  const updateUser = async (userId: string, userData: any) => {
    try {
      const { returnCode, returnObject, returnMessage } =
        await sendPostToServerWithOutToken("auth/update", {
          id: userId,
          ...userData,
        });
      return {
        success: returnCode === 200,
        data: returnObject,
        message: returnMessage,
      };
    } catch (error) {
      console.error("Error updating user:", error);
      return { success: false, error };
    }
  };

  const fetchUsers = async (limit: number, offset: number, postData: any) => {
    try {
      const { returnCode, returnObject } = await sendPostToServer(
        `auth/get-all-users?limit=${limit}&offset=${offset}`,
        postData
      );
      return returnCode === 200 && returnObject;
    } catch (error) {
      console.error("Error fetching institutions:", error);
      return [];
    }
  };

  return {
    fetchRegions,
    fetchDistricts,
    fetchCounties,
    fetchSubCounties,
    fetchParishes,
    fetchInstitutions,
    fetchBranches,
    fetchServiceCategories,
    createInstitution,
    createBranch,
    createServiceCategory,
    createUser,
    updateUser,
    fetchUsers,
  };
};
